import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getScraperRunLogs,
  getScraperRuns,
  getScrapersSources,
  type ScraperRunLogsOptions,
  type ScraperRunsOptions,
} from "@/services/scrapersApi";

export const scrapersKeys = {
  all: ["scrapers"] as const,
  sources: () => [...scrapersKeys.all, "sources"] as const,
  runs: (options: ScraperRunsOptions) =>
    [...scrapersKeys.all, "runs", options] as const,
};

export function useScrapersSources() {
  return useQuery({
    queryKey: scrapersKeys.sources(),
    queryFn: getScrapersSources,
  });
}

export function useScraperRuns(
  options: ScraperRunsOptions = {},
  refetchInterval?: number,
) {
  return useQuery({
    queryKey: scrapersKeys.runs(options),
    queryFn: () => getScraperRuns(options),
    refetchInterval: refetchInterval ?? 0,
  });
}

export function useScraperRunLogs() {
  return useMutation({
    mutationFn: (options: ScraperRunLogsOptions) => getScraperRunLogs(options),
  });
}
